package org.vreo.devicehub.features.core.data.device.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Data class representing the response from a direct message request.
 */
@Serializable
data class DirectMessageResponseDto(
    @SerialName("deviceId") val deviceId: String,
    @SerialName("status") val status: Int,
    @SerialName("message") val message: String,
)